export class Folder {

  folderName: string;
  folderDescription:string;
  folderSecret:string;
  active : boolean;
  status: boolean;
  folderUid:string;
  background : string;
  createdAt : number = new Date().getTime();

  constructor(data:any) {
    this.folderName   = data.folderName
    this.folderDescription = data.folderDescription
    this.folderSecret = this.randomPassword(8);
    this.status = true
    this.active = true
    this.folderUid = data.$key || ''
    this.background = this.getRandomColor();
    this.createdAt = new Date().getTime()
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF'.split('');
    let color = '#';
    for ( let i = 0; i < 6; i++ ) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

   randomPassword(length) {
    var chars = "abcdefghijklmnopqrstuvwxyz!@&*ABCDEFGHIJKLMNOP1234567890";
    var pass = "";
    for (var x = 0; x < length; x++) {
        var i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
    }
    return pass;
}
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/models/folder.ts